import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Footer } from './footerModel';
import { Observable } from 'rxjs';
import { DataContextService } from '../services/datacontext.service';
import { env } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class FooterService extends DataContextService<Footer> {

  constructor(http: HttpClient) {    
    super(http, env.API.footer_api_url);   
  }
 
  getData(): Observable<any> {
    return this.get(env.API.footer_api_url); 
  }
}